'use client'

import { useEffect, useState } from 'react'

/** Default tick cadence (ms). One minute matches the badge's coarsest granularity. */
const DEFAULT_TICK_MS = 60 * 1000

/**
 * Minutes remaining until `lessonStartUnixSec`, re-computed on a tick interval so
 * countdown badges (D-N / N시간 전 / N분 전) stay fresh without a manual refresh.
 *
 * Clamped to 0 so past-dated inputs render "0분 전" rather than a negative number.
 *
 * @param lessonStartUnixSec - Unix seconds (UTC) of the lesson start.
 * @param tickMs - Poll interval in milliseconds. Defaults to 60s.
 */
export const useMinutesUntil = (lessonStartUnixSec: number, tickMs: number = DEFAULT_TICK_MS): number => {
  const [nowMs, setNowMs] = useState<number>(() => Date.now())

  useEffect(() => {
    const id = setInterval(() => setNowMs(Date.now()), tickMs)
    return () => clearInterval(id)
  }, [tickMs])

  return Math.max(0, Math.floor((lessonStartUnixSec - nowMs / 1000) / 60))
}
